import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

const Home = lazy(() => import('./pages/Home'))
const Login = lazy(() => import('./pages/Login'))
const RequestDemo = lazy(() => import('./pages/RequestDemo'))

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Suspense fallback={<p>Loading..</p>} >
        <Switch>
          <Route exact path='/' component={Home} />
          <Route path='/login' component={Login} />
          <Route path='/request-demo' component={RequestDemo} />
        </Switch>
      </Suspense>
    </Router>
  );
}

export default App;
